// import React from 'react';
import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/departamentos';

const departamentosApi = {
    crear: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/crear`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            // Validar retorno de array
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de departamento:', error);
            return [];
        }
    },

    detalle: async (id : string) => {
        try {
            const response = await axios.get(`${BASE_URL}/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching informacion de departamento:', error);
        return [];
    }
},

    editar: async (id : string) => {
        try {
            const response = await axios.get(`${BASE_URL}/editar/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching informacion de edicion de departamento:', error);
        return [];
    }
},

    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
    } catch (error) {
        console.error('Error fetching departamentos:', error);
        return [];
    }
},

    baja: async (id : string) => {
        try {
            const response = await axios.get(`${BASE_URL}/baja/${id}`, {
                headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        // Validar retorno de array
        return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching informacion de baja de departamento:', error);
            return [];
        }
    },

    crearUsuarioDepartamento: async (data: { UsuarioId: number | string; DepartamentoId: number | string; CreatedDate: string; LastModifiedDate: string }) => {
        const response = await axios.post(
            `https://inventariosbackend.velasresorts.com/inventarios/usuariosdepartamentos/crear`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    },

    listadoUsuariosDepartamentos: async () => {
        try {
            const response = await axios.get(`https://inventariosbackend.velasresorts.com/inventarios/usuariosdepartamentos/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching usuarios-departamentos:', error);
            return [];
        }
    },

    darBajaUsuarioDepartamento: async (id: number | string) => {
        const response = await axios.put(
            `https://inventariosbackend.velasresorts.com/inventarios/usuariosdepartamentos/baja/${id}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    }
};

export default departamentosApi;